<template>
    <CModal
      :title="title"
      :color="color"
      size="lg"
      :show.sync="uploadModal"
    >   
        <CForm id="travel_form" method="POST" enctype="multipart/form-data">
            <CRow>
              <CCol md="12">
                <CSelect
                  name="payment_method"
                  id="payment_method"
                  label="Selecciona forma de pago:"
                  :options="[
                    { value: 'card', label: 'Tarjeta' },
                    { value: 'deposit', label: 'Depósito' },
                    { value: 'cash', label: 'Efectivo' }
                  ]"
                  :value.sync="$v.form.payment_method.$model"
                />
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12">
                <CInput
                    type="number"
                    inputmode="numeric"
                    pattern="\d*"
                    name="amount"
                    id="amount"
                    label="Escribe el monto pagado (Ejemplo: 7000):"
                    :lazy="false"
                    :value.sync="$v.form.amount.$model"
                />
                <div v-if="$v.form.amount.$error" class="text-danger" style="font-size: 0.85rem;">
                  <div v-if="!$v.form.amount.required">Este campo es obligatorio.</div>
                  <div v-if="!$v.form.amount.minValue">El monto debe ser mayor a cero.</div>
                </div>
              </CCol>
              
            </CRow>
            <CRow>
              <CCol md="12">
                <label>Adjunta una foto del comprobante de pago, favor de escribir el nombre del alumno en la referencia o concepto:</label>
                <CInputFile
                  :key="fileInputKey"
                  ref="inputFile"
                  name="image"
                  id="image"
                  :custom="true"
                  accept="image/*,.pdf"
                  @change="onFileChange"
                />
                <div v-if="$v.form.image.$error" class="text-danger" style="font-size: 0.85rem; margin-top: 6px;">
                  Adjunta una imagen o PDF del comprobante.
                </div>
              </CCol>
            </CRow>
            <CRow class="mb-3">
              <CCol md="12" class="text-right">
                <a href="#" @click="showExample()">Ver ejemplo</a>
              </CCol>
            </CRow>
            <CRow v-if="imagePreview" class="mt-3">
              <CCol md="12">
                <img :src="imagePreview" alt="Preview" style="max-width: 150px; max-height: 150px; border: 1px solid #ddd; padding: 5px;" />
              </CCol>
            </CRow>
        </CForm>
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="store" :color="color">Enviar</CButton>
        </template>
        <DocumentExampleModal ref="documentExampleModal"></DocumentExampleModal>
    </CModal>
</template>

<script>
import { validationMixin } from "vuelidate"
import { required, minLength, minValue } from "vuelidate/lib/validators"
import { DatePicker } from 'v-calendar'
import { VueEditor } from "vue2-editor";
import DocumentExampleModal from "./DocumentExampleModal.vue";

import moment from 'moment';
import moment_timezone from 'moment-timezone'

moment.tz.setDefault('America/Mexico_city')

let today = new moment();
today = new moment(today.format("YYYY-MM-DD HH:m:ss")); 
let today2 = new moment(today.format("YYYY-MM-DD HH:m:ss")).subtract(1, 'month');

export default {
  name: 'UploadPaymentModal',
  components: {
    'v-date-picker': DatePicker,
    VueEditor,
    DocumentExampleModal
  },
  props: {
    
  },
  data () {
    return {
      uploadModal: false,
      title: "Comprobante de Pago",
      color: "info",
      isEdit: false,
      form: this.getEmptyForm(),
      schools: [],
      schoolsOptions: [],
      submitted: false, 
      content: "<h1>Some initial content</h1>",
      imagePreview: null,
      fileInputKey: 0, // <-- para forzar re-render del input
      fields: [
        {key: 'name', label: 'Nombre'},
        {key: 'actions', label: '', class: 'actions' }
      ]
    }
  },
  mounted: async function() {
  },
  methods: {
    resetFileInput () {
      // limpiar el input real
      const input = this.$refs.inputFile?.$el.querySelector('input[type="file"]')
      if (input) input.value = null

      // limpiar form y previews
      this.form.image = null
      if(this.imagePreview) URL.revokeObjectURL(this.imagePreview)
      this.imagePreview = null

      // forzar re-render del componente input file
      this.fileInputKey++
    },
    showExample(){
      this.$refs.documentExampleModal.openModal();
    },
    onFileChange() {
      const input = this.$refs.inputFile.$el.querySelector('input[type="file"]')
      const file = input.files && input.files[0]
      if (!file) return

      if(this.imagePreview) URL.revokeObjectURL(this.imagePreview)
      this.form.image = file
      this.imagePreview = URL.createObjectURL(file)
    },
    storeModal (payment) {
      this.uploadModal = true;
      this.color = "info";
      this.title = 'Comprobante de Pago';

      this.form = {
          id: payment.id,
          amount: '',
          image: null,
          payment_method: 'card'
      }
      this.resetFileInput();
    },
    store () {
      this.$v.$touch()
      if (this.$v.$invalid) return
      const form = document.getElementById("travel_form")
      const formData = new FormData(form)

      formData.append("id", this.form.id)
      formData.append("payment_method", this.form.payment_method);
      this.$emit("store", formData );

      this.closeModal();
    },
    closeModal () {
      this.uploadModal = false;

      this.form = this.getEmptyForm()
      this.submitted = false
      this.$v.$reset()
    },
    getEmptyForm () {
      let form = {
          id: 0,
          amount: '',
          image: null,
          payment_method: 'card'
      };      

      return form;
    },
    checkIfValid (fieldName) {
      const field = this.$v.form[fieldName]
      if (!field.$dirty) {
        return null
      }
      
      return !(field.$invalid || field.$model === '')
    },
  },
  computed: {
    formString () { return JSON.stringify(this.form, null, 4) },
    isValid () { return !this.$v.form.$invalid },
    isDirty () { return this.$v.form.$anyDirty },
  },
  mixins: [validationMixin],
  validations: {
    form: {
      amount: {
        required,
        minValue: minValue(1)
      },
      payment_method: {
        required
      },
      image: {
        required
      }
    }
  },
}
</script>